import SmallMultiple from "./SmallMultiple/SmallMultipleMain";

const BiomasseSmallMultipleSize = ({ title, location_key, colors }) => {
  const items = [
        {
            title: "< 150 kW", 
            explanationText: `Biomasseanlagen dieser Größenordnung sind typischerweise in landwirtschaftlichen Betrieben 
            oder kleinen Gewerben im Einsatz. Sie dienen häufig der Eigenversorgung mit Strom und Wärme und nutzen Reststoffe wie Gülle, Holz oder Bioabfälle. Ihre geringe Leistung ermöglicht eine dezentrale Energieversorgung im ländlichen Raum.`, 
            size_category: "Power_0_150"
          },
          { 
            title: "150-500 kW", 
            explanationText: `Anlagen dieser Klasse sind meist für mittlere Betriebe oder Nahwärmenetze ausgelegt. Sie kombinieren 
            eine höhere Effizienz mit größerer Flexibilität bei den eingesetzten Brennstoffen. Solche Anlagen tragen zur 
            lokalen Energieversorgung bei und werden oft durch Einspeisevergütungen wirtschaftlich unterstützt.`, 
            size_category: "Power_150_500"  
          },
          { 
            title: "500 kW - 20 MW", 
            explanationText: `Diese Biomasseanlagen gehören zur industriellen Mittel- und Großklasse. Sie versorgen größere Netze 
            mit Strom und Wärme, häufig im Rahmen von Kraft-Wärme-Kopplung. Die Anlagen setzen auf professionelle Brennstofflogistik 
            und erzielen durch kontinuierlichen Betrieb eine hohe Auslastung und Effizienz.`, 
            size_category: "Power_500_20000"  
          },
          { 
            title: ">= 20 MW", 
            explanationText: `Großanlagen dieser Kategorie sind eher selten, aber sie spielen eine bedeutende Rolle in der industriellen 
            und kommunalen Energieversorgung. Sie nutzen oft Reststoffe aus der Holz- oder Abfallwirtschaft in großem Maßstab und speisen zuverlässig Strom ins Netz ein. Aufgrund ihrer Größe unterliegen sie besonders strengen Umweltauflagen.`, 
            size_category: "Power_20000"  
          },
    ];
    
  return (
    <>
      <h3 className="text-xl mt-10 mb-2 font-semibold text-center">{title}</h3>
      <div className="flex flex-wrap justify-center gap-4 rounded-lg">
        {items.map(({ size_category, title, explanationText }, index) => (
          <div
            key={index}
            className="text-center flex-1 min-w-[220px] max-w-xs flex flex-col"
            style={{ flexBasis: "220px" }}
          >
            <SmallMultiple
              textData={{
                summary: title,
                popoverText: explanationText,
              }}
              donutSpec={title}
              location_key={location_key}
              energySource={"BM"}
              unit={"MW"}
              smallMultipleType="size"
              LineChartTitle={'Installierte Leistung in MW'}
              category={size_category}
              colors={colors}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default BiomasseSmallMultipleSize;
